import { Component, OnInit, NgZone, ViewChild, ElementRef, HostListener, Input, ViewEncapsulation } from '@angular/core';
import { getDeviceSize, detectbrowser } from 'src/app/utilities/utilities.file';
import { IwService } from 'src/app/services/iw.service';
import { base_https_url, ISTATACARD, HEADER_TEXT, IS_CAMPAIGN } from 'src/app/config/app-settings.config';
import { SharedServiceService } from 'src/app/services/shared-service.service';
import { ActivatedRoute } from '@angular/router';
import { Router } from "@angular/router";
import { ThemeService } from 'src/app/services/theme.service';
import {CatalogueService} from 'src/app/services/catalogue.service'
declare var $: any;
declare var analytics : any;

@Component({
  selector: 'app-qde-header',
  templateUrl: './qde-header.component.html',
  styleUrls: ['./qde-header.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class QdeHeaderComponent implements OnInit {
  isMobile: boolean;
  breakpoint: number;

  @ViewChild('stickyPanel') stickeyElement: ElementRef;
  sticky = false;
  elementPosition: any;
  @Input() cardDcrData: any;
  _cardName: any;
  _cardBenefits: any;
  eapplyFormLabel: any;
  header_img: any;
  stickyForChrome: boolean = false;
  convertedjson: any;
  convertedjsonLi: any;
  heading: any;
  cardNameHeading: any;
  headerText: any;
  applicantName: any;
  isBanca: boolean = false;
  isCampion = IS_CAMPAIGN;
  fetchName:any;
  partnerTheme: any;
  referJourney:boolean = false;
  partnerCode: any = sessionStorage.getItem('partner-code');
  containerType: any = sessionStorage.getItem('container-type');

  constructor(
    private ngZone: NgZone,
    private iw: IwService,
    private route: ActivatedRoute,
    private router: Router,
    private sharedService: SharedServiceService,
    private catalogueService:CatalogueService,
    private themeService: ThemeService
  ) { 
    this.partnerCode = this.themeService.partnerCode;
  }

  ngOnInit() {
    this.route.queryParams.subscribe(query => {
      if(query.theme){
        this.partnerTheme = query.theme;
        // this.setThemeByParam(theme);
      }
    });
    this.applicantName = this.sharedService.applicantName
    this.headerText = HEADER_TEXT;
    this.referJourney = this.catalogueService.referralCode ? true : false;
    console.log(this.referJourney);
    this.eapplyFormLabel = this.iw.geteapplyFormLabelDcr().dcrContent.root;
    if (getDeviceSize() === 'small') {
      this.isMobile = true;

    }

    window.onresize = (e) => {
      this.ngZone.run(() => {
        if (getDeviceSize() === 'small') {
          this.isMobile = true;
        } else {
          this.isMobile = false;
        }
      })
    }
    this.isBanca = this.sharedService.paramschannel && this.sharedService.paramschannel == '901' ? true : false;
    this.getName();
  }

  ngOnChanges() {
    const xml = this.cardDcrData;
    this.applicantName = this.sharedService.applicantName
    this.applicantName = this.sharedService.applicantName
    if (xml && xml.root) {
      if (xml && xml.root && xml.root.card_information && xml.root.card_information.card_image_container && xml.root.card_information.card_image_container.image_url) {
        this.header_img = base_https_url + xml.root.card_information.card_image_container.image_url;
      }

      if (xml && xml.root && xml.root.card_information && xml.root.card_information.card_name) {
        this.cardNameHeading = xml.root.card_information.card_name;
      }
      if (xml && xml.root && xml.root['eapply-benefits1'] && xml.root['eapply-benefits1'].benefits && xml.root['eapply-benefits1'].benefits.benefits_desc ) {
         this.convertedjsonLi = '' + xml.root['eapply-benefits1'].benefits.benefits_desc
      }
      if (xml && xml.root && xml.root['eapply-benefits1'] && xml.root['eapply-benefits1'].benefits && xml.root['eapply-benefits1'].benefits.benefits_heading) {
        this.heading = xml.root['eapply-benefits1'].benefits.benefits_heading;
      }
    }

  }

  ngAfterViewInit() {
    this.elementPosition = this.stickeyElement.nativeElement.getBoundingClientRect().top;
  }

  @HostListener('window:scroll', ['$event'])
  handleScroll() {
    if (detectbrowser().toLowerCase().includes('chrome')) {
      this.stickyForChrome = (window.pageYOffset >= this.elementPosition);
      this.sticky = false;
    }
    else {
      this.sticky = (window.pageYOffset >= this.elementPosition);
    }
  }

  getName(){
    this.sharedService.nameObservable.subscribe(res =>{
      this.fetchName=res;
      this.fetchName = this.fetchName? this.fetchName + ',' : '';
    });
  }

  changeCardPartner(){
    this.router.navigate(['./catalogue-partner'], { queryParamsHandling: "preserve", skipLocationChange: this.partnerCode && this.containerType?true:false });
  }
  changeCardRefer(){
    this.router.navigate(['./catalogue-refer'], { queryParamsHandling: "preserve", skipLocationChange: this.partnerCode && this.containerType?true:false });
  }
  
track(){ 
  
  /* Analytics added */
  if(window['analytics']){
       analytics.track('eapply__click__change_card', {
      'MODE_OF_CONVERSION': '',
      'IS_ORGANIC': 'N',
      'SOURCE_GEM_ID1':  this.sharedService.paramsgemid1,
      'SOURCE_GEM_ID2': this.sharedService.paramsgemid2,
      'SOURCE_PAGE_URL': window["digitalData"].page.SOURCE_PAGE_URL,
      'CHANNEL_NAME':this.sharedService.paramschannel,
      'JOURNEY_NAME': 'EAPPLY',
      'CARD_TYPE': this.cardDcrData.root.card_information.card_type
      })
  }

}

}
